import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import img1 from "../Assets/images/Frame56.png"
import img2 from "../Assets/images/Group11.png"
import { LiaCheckCircleSolid } from "react-icons/lia";
import img3 from "../Assets/images/Group (12).png"
import img4 from "../Assets/images/Group (13).png"
import img5 from "../Assets/images/Group (11).png"
import img6 from "../Assets/images/Group (14).png"
import img7 from "../Assets/images/Frame 170.png"
import img8 from "../Assets/images/Frame 172.png"
import img9 from "../Assets/images/Frame 173.png"
import img10 from "../Assets/images/Frame 174.png"
import img11 from "../Assets/images/Frame 175.png"
import img12 from "../Assets/images/Frame 176.png"
import img13 from "../Assets/images/Frame 189.png"
import img14 from "../Assets/images/Frame 188.png"
import img15 from "../Assets/images/Frame 184.png"
import img16 from "../Assets/images/Frame 187.png"
import img17 from "../Assets/images/Frame 185.png"
import img18 from "../Assets/images/Frame 186.png"
import img19 from "../Assets/images/Frame 199.png"
import img20 from "../Assets/images/Frame 200.png"
import img21 from "../Assets/images/Frame 201.png"
import img22 from "../Assets/images/Frame 202.png"
import imgTex from "../Assets/images/Group (15).png"
import img23 from "../Assets/images/Frame 98.png"
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';


function Bareq() {

    const { t } = useTranslation();

    return (
        <div className='bareq-sec'>

            <div className='first-section pt-5'>
                <Container>
                    <Row className='gx-5'>
                        <Col md={7}>
                            <div>
                                <div className='d-flex align-items-center justify-content-center mb-5'>
                                    <img src={img2} alt='' className='stat-img' />
                                </div>
                                <div className='head-sec'>
                                    <h5>{t("bareqPage.subtitle")}  </h5>
                                    <p> {t("bareqPage.description")} </p>
                                </div>
                            </div>
                        </Col>
                        <Col md={5}>
                            <div className='img-sec'>
                                <img src={img1} alt='' />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div className='seconed-section mt-5'>
                <Container>
                    <h5 className='text-center'> {t("bareqPage.language_skills_title")} </h5>
                    <p> {t("bareqPage.language_skills_description")} </p>
                    <Row className='my-5 gx-5'>
                        <Col md={3}>
                            <div className='card card1'>
                                <div className='p-4 d-flex align-items-center justify-content-center'>
                                    <img src={img3} alt='' className='p-2' />
                                </div>
                                <button> {t("bareqPage.skill_listening")} </button>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className='card card2'>
                                <div className='p-4 d-flex align-items-center justify-content-center'>
                                    <img src={img4} alt='' className='p-2' />
                                </div>
                                <button>  {t("bareqPage.skill_speaking")}</button>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className='card card3'>
                                <div className='p-4 d-flex align-items-center justify-content-center'>
                                    <img src={img5} alt='' className='p-2' />
                                </div>
                                <button> {t("bareqPage.skill_writing")} </button>
                            </div>
                        </Col>
                        <Col md={3}>
                            <div className='card card4'>
                                <div className='p-4 d-flex align-items-center justify-content-center'>
                                    <img src={img6} alt='' className='p-2' />
                                </div>
                                <button> {t("bareqPage.skill_reading")} </button>
                            </div>
                        </Col>
                    </Row>
                    <Row className='m-sec align-items-center'>
                        <Col md={4}>
                            <img src={img7} alt='' className='stat-img w-100' />
                        </Col>
                        <Col md={8}>
                            <div>
                                <h5> {t("bareqPage.are_you_ready")} </h5>
                                <p> {t("bareqPage.levels_desc")} </p>
                            </div>
                        </Col>
                    </Row>
                    <div className='grid-sec mb-5'>
                        <div className='card card1'>
                            <div className='p-3 d-flex align-items-center justify-content-center'>
                                <img src={img8} alt='' className='p-2' />
                            </div>
                            <button> {t("bareqPage.learning_arabic_alphabet")} </button>
                        </div>
                        <div className='card card2'>
                            <div className='p-3 d-flex align-items-center justify-content-center'>
                                <img src={img9} alt='' className='p-2' />
                            </div>
                            <button> {t("bareqPage.level_one")} </button>
                        </div>
                        <div className='card card3'>
                            <div className='p-3 d-flex align-items-center justify-content-center'>
                                <img src={img10} alt='' className='p-2' />
                            </div>
                            <button> {t("bareqPage.level_two")} </button>
                        </div>
                        <div className='card card4'>
                            <div className='p-3 d-flex align-items-center justify-content-center'>
                                <img src={img11} alt='' className='p-2' />
                            </div>
                            <button> {t("bareqPage.level_three")} </button>
                        </div>
                        <div className='card card4'>
                            <div className='p-3 d-flex align-items-center justify-content-center'>
                                <img src={img12} alt='' className='p-2' />
                            </div>
                            <button> {t("bareqPage.level_four")} </button>
                        </div>
                    </div>
                </Container>

            </div>

            <div className='third-section mt-5'>
                <Container>
                    <h5> {t("bareqPage.main_features")} </h5>
                    <Row className='pt-4 gy-5'>
                        <Col md={6}>
                            <div className='d-flex align-items-start'>
                                <img src={img13} alt='' />
                                <div className='mx-3'>
                                    <h6> {t("bareqPage.assessment")}  </h6>
                                    <p> {t("bareqPage.assessment_desc")}  </p>
                                </div>
                            </div>
                        </Col>

                        <Col md={6}>
                            <div className='d-flex align-items-start'>
                                <img src={img14} alt='' />
                                <div className='mx-3'>
                                    <h6> {t("bareqPage.learning_systems")} </h6>
                                    <p> {t("bareqPage.learning_systems_desc")} </p>
                                </div>
                            </div>
                        </Col>

                        <Col md={6}>
                            <div className='d-flex align-items-start'>
                                <img src={img15} alt='' />
                                <div className='mx-3'>
                                    <h6> {t("bareqPage.gamification")}  </h6>
                                    <p> {t("bareqPage.gamification_desc")} </p>
                                </div>
                            </div>
                        </Col>

                        <Col md={6}>
                            <div className='d-flex align-items-start'>
                                <img src={img16} alt='' />
                                <div className='mx-3'>
                                    <h6> {t("bareqPage.flexibility")} </h6>
                                    <p> {t("bareqPage.flexibility_desc")} </p>
                                </div>
                            </div>
                        </Col>

                        <Col md={6}>
                            <div className='d-flex align-items-start'>
                                <img src={img17} alt='' />
                                <div className='mx-3'>
                                    <h6> {t("bareqPage.interactivity")}  </h6>
                                    <p> {t("bareqPage.interactivity_desc")} </p>
                                </div>
                            </div>
                        </Col>

                        <Col md={6}>
                            <div className='d-flex align-items-start'>
                                <img src={img18} alt='' />
                                <div className='mx-3'>
                                    <h6> {t("bareqPage.comprehensive_academic_support")}  </h6>
                                    <p> {t("bareqPage.comprehensive_academic_support_description")} </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className='fourth-section'>
                <Container>
                    <div className='relative-sec'>
                        <Row>
                            <Col md={2} >
                                <img src={img19} alt='' style={{ position: "absolute", top: "-50px", width: "265px" }} className='relative-img' />
                            </Col>
                            <Col md={10} className='d-flex align-items-start ' style={{ background: "white", padding: "60px 70px" }}>
                                <img src={imgTex} alt='' />
                                <div>
                                    <h6> {t("bareqPage.bareq_self_learning")} </h6>
                                    <p> {t("bareqPage.bareq_self_learning_desc")} </p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className='relative-sec'>
                        <Row>
                            <Col md={10} className='d-flex align-items-start ' style={{ background: "white", padding: "60px 70px" }}>
                                <img src={imgTex} alt='' />
                                <div>
                                   <h6> {t("bareqPage.bareq_blended_learning")} </h6>
                                    <p> {t("bareqPage.bareq_blended_learning_desc")} </p>
                                </div>
                            </Col>
                            <Col md={2} >
                                <img src={img20} alt='' className='floatedImg k12-books-items-position' style={{ position: "absolute", top: "-50px", width: "265px" }} />
                            </Col>
                        </Row>
                    </div>
                    <div className='relative-sec'>
                        <Row>
                            <Col md={2} >
                                <img src={img21} alt='' className='relative-img' style={{ position: "absolute", top: "-50px", width: "265px" }} />
                            </Col>
                            <Col md={10} className='d-flex align-items-start ' style={{ background: "white", padding: "60px 70px" }}>
                                <img src={imgTex} alt='' />
                                <div>
                                    <h6> {t("bareqPage.bareq_remedial_learning")} </h6>
                                    <p> {t("bareqPage.bareq_remedial_learning_desc")} </p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className='relative-sec'>
                        <Row>
                            <Col md={10} className='d-flex align-items-start ' style={{ background: "white", padding: "60px 70px" }}>
                                <img src={imgTex} alt='' />
                                <div>
                                     <h6> {t("bareqPage.bareq_enrichment_program")} </h6>
                                    <p> {t("bareqPage.bareq_enrichment_program_desc")} </p>
                                </div>
                            </Col>
                            <Col md={2} >
                                <img src={img22} alt='' className='floatedImg k12-books-items-position' style={{ position: "absolute", top: "-50px", width: "265px"}} />
                            </Col>
                        </Row>
                    </div>
                </Container>

            </div>

            <div className='fifth-section last-sec'>
                <Container>
                    <Row className='align-items-center'>
                        <Col md={7}>
                            <h6> {t("bareqPage.bareq_title")} </h6>
                            <p> {t("bareqPage.bareq_description")} </p>
                            <button onClick={() => window.location.href = 'https://bareq.me/login'}>
                                {t("bareqPage.get_started_today")}
                            </button>
                        </Col>
                        <Col md={5}>
                            <img src={img23} alt='' className='w-100' />
                        </Col>
                    </Row>
                </Container>
            </div>

        </div>

    )
}

export default Bareq
